import { module } from 'angular';
import { baseModuleId } from '../common/constants/base-module-id';
import { FallbackSrcDirective } from './fallback-src.directive';
export var FallbackSrcComponentNgModule = module(baseModuleId + ".fallback-src", [])
    .directive('fallbackSrc', FallbackSrcDirective);
